import { render, staticRenderFns } from "./BasicInfoModule.vue?vue&type=template&id=7a2b3e19&"
import script from "./BasicInfoModule.vue?vue&type=script&lang=js&"
export * from "./BasicInfoModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports